import axios from 'axios';
import _ from 'lodash';

const axiosInstance = axios.create();

export default {
    getList: () => {
        return axiosInstance.get('/admin/api/tableauMenuFolders')
    },
    create: (data) => {
        return axiosInstance.post('/admin/api/tableauMenuFolders', data)
    },
    edit: (id, data) => {
        data = _.pick(data, ['tableauMenuFolderId', 'title', 'parentId']);
        return axiosInstance.put(`/admin/api/tableauMenuFolders/${id}`, data)
    },
    delete: (id) => {
        return axiosInstance.delete(`/admin/api/tableauMenuFolders/${id}`)
    }
}